import { formatDateLocalWithTime } from "../../../../lib/script";
import classes from './VerificationHistoryList.module.css';

export default function VerificationHistoryList({verificationHistory}) {
    return <div className={classes.verification_history_list_container}>
    <table className="table-border-radius-8">
        <thead>
            <tr>
                <th className="table-cell-fit">Verified By</th>
                <th className="table-cell-fit">Verified At</th>
                <th className="table-cell-fit">Spoke To</th>
                <th>Notes</th>
            </tr>
        </thead>
        <tbody>
            {verificationHistory && verificationHistory.length > 0 && verificationHistory.map(item => (
                <tr key={item.id || item.verified_date}>
                    <td className="table-cell-fit">{item.verified_by}</td>
                    <td className="table-cell-fit">{formatDateLocalWithTime(item.verified_date)}</td>
                    <td className="table-cell-fit">{item.spoke_to}</td>
                    <td><div className={classes.notes_container}>{item.notes}</div></td>
                </tr>
            ))}
            {(!verificationHistory || (verificationHistory && verificationHistory.length === 0)) && <tr>
                <td colSpan={4}>No data found</td>
            </tr>}
        </tbody>
    </table>
    </div>
}